import { Spinner } from "@heroui/react";
import { formatFileSizeSmart } from "@repo/utils/format";
import { formatTime } from "@repo/utils/tools";
import { InfiniteScroll } from "@/components/infinite-scroll";
import { useStorageFileList } from "@/service/hooks/useStorageFileList";

export default function StorageFileUsageList() {
  const { items, loading, loadingMore, hasMore, error, loadMore } = useStorageFileList();

  return (
    <div className="flex flex-col gap-3">
      <div>
        <h2 className="text-base font-semibold text-foreground">用量明细</h2>
        <p className="mt-1 text-sm text-muted">永久存储文件及其占用空间</p>
      </div>

      {loading && items.length === 0 ? (
        <div className="flex justify-center py-10">
          <Spinner />
        </div>
      ) : error && items.length === 0 ? (
        <p className="py-6 text-center text-sm text-danger">{error}</p>
      ) : (
        <InfiniteScroll
          loading={loadingMore}
          hasMore={hasMore}
          onLoadMore={loadMore}
          loadingText="加载中"
          noMoreText="没有更多了"
        >
          {items.length === 0 ? (
            <p className="py-6 text-center text-sm text-muted">暂无永久存储文件</p>
          ) : (
            <ul className="flex flex-col gap-2">
              {items.map((item) => (
                <li
                  key={item.id}
                  className="flex items-start justify-between gap-3 rounded-lg bg-default-100 px-3 py-3"
                >
                  <div className="min-w-0 flex flex-col gap-1">
                    <span className="truncate text-sm font-medium text-foreground">
                      {item.file_name || "-"}
                    </span>
                    <span className="text-xs text-muted">
                      {item.created_at
                        ? formatTime(item.created_at, "YYYY-MM-DD HH:mm")
                        : "-"}
                    </span>
                  </div>
                  <span className="shrink-0 text-sm font-medium tabular-nums text-foreground">
                    {formatFileSizeSmart(item.file_size)}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </InfiniteScroll>
      )}
    </div>
  );
}
